// extracted by mini-css-extract-plugin
module.exports = {"vanlife-L-power-series":"Series_vanlife-L-power-series__ghUmw"};